<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9259_4677)">
<path d="M11 1C11 0.447715 11.4477 0 12 0H14C14.5523 0 15 0.447715 15 1V15H16V16H0V15H1V12C1 11.4477 1.44772 11 2 11H4C4.55228 11 5 11.4477 5 12V15H6V8C6 7.44772 6.44772 7 7 7H9C9.55229 7 10 7.44772 10 8V15H11V1Z" fill="#38AF8D"/>
</g>
<defs>
<clipPath id="clip0_9259_4677">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
